export function getViteVersionCommitSha(): string{
    return import.meta.env.VITE_VERSION_COMMIT_SHA;
}